export default __webpack_public_path__ + "static/media/README.461047be.md";